module.exports = __webpack_public_path__ + "static/media/deliveryVan_green.e6fe9fe0.svg";